import { useMemo } from "react";
import { useAuth } from "@/context/auth";
import { $api } from "@/lib/api-client";

export const useFavoritesLookup = () => {
  const { isLoggedIn } = useAuth();

  const query = $api.useQuery(
    "get",
    "/favorites/ids",
    {},
    { enabled: isLoggedIn },
  );

  const set = useMemo(
    () => new Set<string>(query.data?.data ?? []),
    [query.data],
  );

  return {
    set,
    refetch: query.refetch,
    isLoading: query.isLoading,
  };
};
